/* tslint:disable */
/* eslint-disable */
/**
 * Illio Wealth API
 * [Environment: dev], Manage your account, add trades, view portfolio performance and pnl
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@illio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../base';
// @ts-ignore
import { EquityOptionsResponseDtoV3 } from '../../aggregator';
// @ts-ignore
import { ErrorResponseBody } from '../../aggregator';
// @ts-ignore
import { PortfolioAllocationHistoryResponse } from '../../aggregator';
// @ts-ignore
import { ProfitBreakdownResponse } from '../../aggregator';
// @ts-ignore
import { ProfitByAllocationTypeResponse } from '../../aggregator';
// @ts-ignore
import { ProfitByAssetTypeResponse } from '../../aggregator';
// @ts-ignore
import { ProfitByAttributionResponse } from '../../aggregator';
// @ts-ignore
import { ProfitByInstrumentResponse } from '../../aggregator';
// @ts-ignore
import { ProfitChartResponse } from '../../aggregator';
// @ts-ignore
import { ProfitChartResponseV3 } from '../../aggregator';
/**
 * PortfolioProfitApi - axios parameter creator
 * @export
 */
export const PortfolioProfitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquityOptionsData: async (portfolioId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getEquityOptionsData', 'portfolioId', portfolioId)
            const localVarPath = `/v3/portfolio/{portfolioId}/positions/options`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
         * @summary Get portfolio profit breakdown by various allocation types
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAllocation: async (portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getProfitByAllocation', 'portfolioId', portfolioId)
            // verify required parameter 'allocationType' is not null or undefined
            assertParamExists('getProfitByAllocation', 'allocationType', allocationType)
            const localVarPath = `/v3/portfolio/{portfolioId}/profitByAllocationType`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (allocationType !== undefined) {
                localVarQueryParameter['allocationType'] = allocationType;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get portfolio profit by Asset Type
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'AssetSubClass' | 'RiskAssetClass'} assetType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAllocationType: async (portfolioId: string, assetType: 'AssetClass' | 'AssetSubClass' | 'RiskAssetClass', from?: string, to?: string, custodians?: Set<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getProfitByAllocationType', 'portfolioId', portfolioId)
            // verify required parameter 'assetType' is not null or undefined
            assertParamExists('getProfitByAllocationType', 'assetType', assetType)
            const localVarPath = `/v3/portfolio/{portfolioId}/monthOnMonthProfitByAllocationType`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['assetType'] = assetType;
            }

            if (custodians) {
                localVarQueryParameter['custodians'] = Array.from(custodians);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * assetClassId can be any assetClass, assetSubClass or riskAssetClass Code
         * @summary Get portfolio profit by Asset Class
         * @param {string} portfolioId 
         * @param {string} assetClass 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAssetClassId: async (portfolioId: string, assetClass: string, from?: string, to?: string, custodians?: Set<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getProfitByAssetClassId', 'portfolioId', portfolioId)
            // verify required parameter 'assetClass' is not null or undefined
            assertParamExists('getProfitByAssetClassId', 'assetClass', assetClass)
            const localVarPath = `/v3/portfolio/{portfolioId}/profitByAssetClass`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assetClass !== undefined) {
                localVarQueryParameter['assetClass'] = assetClass;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }

            if (custodians) {
                localVarQueryParameter['custodians'] = Array.from(custodians);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get portfolio profit by Attribution
         * @param {string} portfolioId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAttribution: async (portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getProfitByAttribution', 'portfolioId', portfolioId)
            const localVarPath = `/v3/portfolio/{portfolioId}/monthOnMonthProfitByAttribution`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }

            if (assetClass !== undefined) {
                localVarQueryParameter['assetClass'] = assetClass;
            }

            if (custodians) {
                localVarQueryParameter['custodians'] = Array.from(custodians);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get portfolio monthly profit, filtered by assetClass, custodians or none
         * @param {string} portfolioId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitChart: async (portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getProfitChart', 'portfolioId', portfolioId)
            const localVarPath = `/v3/portfolio/{portfolioId}/profitChart`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }

            if (assetClass !== undefined) {
                localVarQueryParameter['assetClass'] = assetClass;
            }

            if (custodians) {
                localVarQueryParameter['custodians'] = Array.from(custodians);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
         * @summary Get portfolio profit history
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitHistory: async (portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getProfitHistory', 'portfolioId', portfolioId)
            // verify required parameter 'allocationType' is not null or undefined
            assertParamExists('getProfitHistory', 'allocationType', allocationType)
            const localVarPath = `/v3/portfolio/{portfolioId}/profitHistory`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (allocationType !== undefined) {
                localVarQueryParameter['allocationType'] = allocationType;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} [assetClass] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profitBreakdown: async (portfolioId: string, assetClass?: string, from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('profitBreakdown', 'portfolioId', portfolioId)
            const localVarPath = `/v3/portfolio/{portfolioId}/profitBreakdown`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assetClass !== undefined) {
                localVarQueryParameter['assetClass'] = assetClass;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substr(0,10) :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} instrumentId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profitByInstrument: async (portfolioId: string, instrumentId: string, fromDate: string, toDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('profitByInstrument', 'portfolioId', portfolioId)
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('profitByInstrument', 'instrumentId', instrumentId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('profitByInstrument', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('profitByInstrument', 'toDate', toDate)
            const localVarPath = `/v3/portfolio/{portfolioId}/profitByInstrument`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (instrumentId !== undefined) {
                localVarQueryParameter['instrumentId'] = instrumentId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioProfitApi - functional programming interface
 * @export
 */
export const PortfolioProfitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioProfitApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEquityOptionsData(portfolioId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquityOptionsResponseDtoV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEquityOptionsData(portfolioId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
         * @summary Get portfolio profit breakdown by various allocation types
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitByAllocation(portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitByAllocationTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitByAllocation(portfolioId, allocationType, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get portfolio profit by Asset Type
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'AssetSubClass' | 'RiskAssetClass'} assetType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitByAllocationType(portfolioId: string, assetType: 'AssetClass' | 'AssetSubClass' | 'RiskAssetClass', from?: string, to?: string, custodians?: Set<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitByAssetTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitByAllocationType(portfolioId, assetType, from, to, custodians, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * assetClassId can be any assetClass, assetSubClass or riskAssetClass Code
         * @summary Get portfolio profit by Asset Class
         * @param {string} portfolioId 
         * @param {string} assetClass 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitByAssetClassId(portfolioId: string, assetClass: string, from?: string, to?: string, custodians?: Set<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitChartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitByAssetClassId(portfolioId, assetClass, from, to, custodians, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get portfolio profit by Attribution
         * @param {string} portfolioId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitByAttribution(portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitByAttributionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitByAttribution(portfolioId, from, to, assetClass, custodians, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get portfolio monthly profit, filtered by assetClass, custodians or none
         * @param {string} portfolioId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitChart(portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitChartResponseV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitChart(portfolioId, from, to, assetClass, custodians, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
         * @summary Get portfolio profit history
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitHistory(portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioAllocationHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitHistory(portfolioId, allocationType, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} [assetClass] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profitBreakdown(portfolioId: string, assetClass?: string, from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitBreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profitBreakdown(portfolioId, assetClass, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} instrumentId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profitByInstrument(portfolioId: string, instrumentId: string, fromDate: string, toDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfitByInstrumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profitByInstrument(portfolioId, instrumentId, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioProfitApi - factory interface
 * @export
 */
export const PortfolioProfitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioProfitApiFp(configuration)
    return {
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquityOptionsData(portfolioId: string, options?: any): AxiosPromise<EquityOptionsResponseDtoV3> {
            return localVarFp.getEquityOptionsData(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
         * @summary Get portfolio profit breakdown by various allocation types
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAllocation(portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options?: any): AxiosPromise<ProfitByAllocationTypeResponse> {
            return localVarFp.getProfitByAllocation(portfolioId, allocationType, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get portfolio profit by Asset Type
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'AssetSubClass' | 'RiskAssetClass'} assetType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAllocationType(portfolioId: string, assetType: 'AssetClass' | 'AssetSubClass' | 'RiskAssetClass', from?: string, to?: string, custodians?: Set<string>, options?: any): AxiosPromise<ProfitByAssetTypeResponse> {
            return localVarFp.getProfitByAllocationType(portfolioId, assetType, from, to, custodians, options).then((request) => request(axios, basePath));
        },
        /**
         * assetClassId can be any assetClass, assetSubClass or riskAssetClass Code
         * @summary Get portfolio profit by Asset Class
         * @param {string} portfolioId 
         * @param {string} assetClass 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAssetClassId(portfolioId: string, assetClass: string, from?: string, to?: string, custodians?: Set<string>, options?: any): AxiosPromise<ProfitChartResponse> {
            return localVarFp.getProfitByAssetClassId(portfolioId, assetClass, from, to, custodians, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get portfolio profit by Attribution
         * @param {string} portfolioId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitByAttribution(portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options?: any): AxiosPromise<ProfitByAttributionResponse> {
            return localVarFp.getProfitByAttribution(portfolioId, from, to, assetClass, custodians, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get portfolio monthly profit, filtered by assetClass, custodians or none
         * @param {string} portfolioId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
         * @param {Set<string>} [custodians] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitChart(portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options?: any): AxiosPromise<ProfitChartResponseV3> {
            return localVarFp.getProfitChart(portfolioId, from, to, assetClass, custodians, options).then((request) => request(axios, basePath));
        },
        /**
         * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
         * @summary Get portfolio profit history
         * @param {string} portfolioId 
         * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitHistory(portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options?: any): AxiosPromise<PortfolioAllocationHistoryResponse> {
            return localVarFp.getProfitHistory(portfolioId, allocationType, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} [assetClass] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profitBreakdown(portfolioId: string, assetClass?: string, from?: string, to?: string, options?: any): AxiosPromise<ProfitBreakdownResponse> {
            return localVarFp.profitBreakdown(portfolioId, assetClass, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} instrumentId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profitByInstrument(portfolioId: string, instrumentId: string, fromDate: string, toDate: string, options?: any): AxiosPromise<ProfitByInstrumentResponse> {
            return localVarFp.profitByInstrument(portfolioId, instrumentId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioProfitApi - object-oriented interface
 * @export
 * @class PortfolioProfitApi
 * @extends {BaseAPI}
 */
export class PortfolioProfitApi extends BaseAPI {
    /**
     * 
     * @param {string} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getEquityOptionsData(portfolioId: string, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getEquityOptionsData(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
     * @summary Get portfolio profit breakdown by various allocation types
     * @param {string} portfolioId 
     * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getProfitByAllocation(portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getProfitByAllocation(portfolioId, allocationType, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get portfolio profit by Asset Type
     * @param {string} portfolioId 
     * @param {'AssetClass' | 'AssetSubClass' | 'RiskAssetClass'} assetType 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {Set<string>} [custodians] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getProfitByAllocationType(portfolioId: string, assetType: 'AssetClass' | 'AssetSubClass' | 'RiskAssetClass', from?: string, to?: string, custodians?: Set<string>, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getProfitByAllocationType(portfolioId, assetType, from, to, custodians, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * assetClassId can be any assetClass, assetSubClass or riskAssetClass Code
     * @summary Get portfolio profit by Asset Class
     * @param {string} portfolioId 
     * @param {string} assetClass 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {Set<string>} [custodians] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getProfitByAssetClassId(portfolioId: string, assetClass: string, from?: string, to?: string, custodians?: Set<string>, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getProfitByAssetClassId(portfolioId, assetClass, from, to, custodians, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get portfolio profit by Attribution
     * @param {string} portfolioId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
     * @param {Set<string>} [custodians] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getProfitByAttribution(portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getProfitByAttribution(portfolioId, from, to, assetClass, custodians, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get portfolio monthly profit, filtered by assetClass, custodians or none
     * @param {string} portfolioId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx'} [assetClass] 
     * @param {Set<string>} [custodians] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getProfitChart(portfolioId: string, from?: string, to?: string, assetClass?: 'CashAndEquivalents' | 'Equities' | 'FixedIncome' | 'RealEstate' | 'Alternatives' | 'Commodities' | 'RealAssets' | 'CryptoCurrencies' | 'SubscriptionWithdrawal' | 'Funds' | 'Adjustments' | 'CFD' | 'Fx', custodians?: Set<string>, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getProfitChart(portfolioId, from, to, assetClass, custodians, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * allocationType can one of AssetClass, RiskAssetClass, Custodian, IndustrySector, Currency, Region
     * @summary Get portfolio profit history
     * @param {string} portfolioId 
     * @param {'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy'} allocationType 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public getProfitHistory(portfolioId: string, allocationType: 'AssetClass' | 'RiskAssetClass' | 'Custodian' | 'IndustrySector' | 'Currency' | 'Region' | 'Strategy', from?: string, to?: string, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).getProfitHistory(portfolioId, allocationType, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} [assetClass] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public profitBreakdown(portfolioId: string, assetClass?: string, from?: string, to?: string, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).profitBreakdown(portfolioId, assetClass, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} instrumentId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioProfitApi
     */
    public profitByInstrument(portfolioId: string, instrumentId: string, fromDate: string, toDate: string, options?: AxiosRequestConfig) {
        return PortfolioProfitApiFp(this.configuration).profitByInstrument(portfolioId, instrumentId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
}
